import React from "react";

import { SvgIcon, SvgIconProps } from "@origin-digital/ods-icons";

const FlashIcon = (props: SvgIconProps) => (
  <SvgIcon size={props.size} viewBox="0 0 24 24">
    <defs>
      <path id="yhgyqjhiea" d="M7 2L7 13 10 13 10 22 17 10 13 10 17 2z" />
      <path id="awl8r1oigc" d="M0 0H50V50H0z" />
    </defs>
    <g fillRule="evenodd">
      <g>
        <mask id="sr2vapcvmb" fill="#fff">
          <use xlinkHref="#yhgyqjhiea" />
        </mask>
        <g mask="url(#sr2vapcvmb)">
          <g transform="translate(-13 -13)">
            <use xlinkHref="#awl8r1oigc" />
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);

const ClockIcon = (props: SvgIconProps) => (
  <SvgIcon size={props.size} viewBox="0 0 24 24">
    <defs>
      <path
        id="vffy4watua"
        d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 4c4.42 0 8 3.58 8 8s-3.58 8-8 8-8-3.58-8-8 3.58-8 8-8zm.5 3H11v6l5.25 3.15.75-1.23-4.5-2.67V7z"
      />
      <path id="pblgtgpd3c" d="M0 0H50V50H0z" />
    </defs>
    <g fillRule="evenodd">
      <g>
        <mask id="w66wajafbb" fill="#fff">
          <use xlinkHref="#vffy4watua" />
        </mask>
        <g mask="url(#w66wajafbb)">
          <g transform="translate(-13 -13)">
            <use xlinkHref="#pblgtgpd3c" />
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);

const BugIcon = (props: SvgIconProps) => (
  <SvgIcon size={props.size} viewBox="0 0 24 24">
    <defs>
      <path
        id="cnwu0g3waa"
        d="M20 8h-2.81c-.45-.78-1.07-1.45-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5c-.49 0-.96.06-1.41.17L8.41 3 7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4v2h2.09c-.05.33-.09.66-.09 1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81c1.04 1.79 2.97 3 5.19 3s4.15-1.21 5.19-3H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20V8zm-6 8h-4v-2h4v2zm0-4h-4v-2h4v2z"
      />
      <path id="9vfjqg1zwc" d="M0 0H50V50H0z" />
    </defs>
    <g fillRule="evenodd">
      <g>
        <mask id="xljypgjknb" fill="#fff">
          <use xlinkHref="#cnwu0g3waa" />
        </mask>
        <g mask="url(#xljypgjknb)">
          <g transform="translate(-13 -13)">
            <use xlinkHref="#9vfjqg1zwc" />
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export { FlashIcon, ClockIcon, BugIcon };
